import React from 'react';
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import './styles.less';

const I18N_BASE_PATH = 'pages.private.KYBCompany.pages.companyDetails.subPages.people';

const renderRow = (item) => {
  return (
    <Row className="wrapper-row-content">
      <Col span={12} className="column-description">
        <strong>{item?.title ?? '-'}</strong>
      </Col>
      <Col span={12} className="column-message">
        <span>{item?.content ?? '-'}</span>
      </Col>
    </Row>
  );
};

const PeopleSummary = ({ data = [] }) => {
  const { t: translate } = useTranslation();

  const halfLength = Math.ceil(data?.length / 2);
  const leftSide = data?.slice(0, halfLength);
  const rightSide = data?.slice(halfLength, data?.length);

  return (
    <div className="KYB-people-summary">
      <h5>{translate(`${I18N_BASE_PATH}.summary.title`, 'People Summary')}</h5>
      <Row className="card">
        <Col span={12} className="wrapper-col-content">
          {leftSide?.map((item) => (
            <React.Fragment key={item.title}>{renderRow(item)}</React.Fragment>
          ))}
        </Col>
        <Col span={12} className="wrapper-col-content">
          {rightSide?.map((item) => (
            <React.Fragment key={item.title}>{renderRow(item)}</React.Fragment>
          ))}
        </Col>
      </Row>
    </div>
  );
};

export default PeopleSummary;
